import api from './api';
import types from './mutation-types';
import _ from 'lodash';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPopupInit_({ commit }) {
		commit(types.POPUP_INIT);
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setPopupSearchParam_({ commit }, { key, value }) {
		commit(types.POPUP_SEARCH_PARAM, { key, value });
	},
	setSelectedRow_({ commit }, { key, value }) {
		commit(types.SELECTED_ROW, { key, value });
	},
	setPopupPagingInfo_({ commit }, { key, value }) {
		commit(types.POPUP_PAGING_INFO, { key, value });
	},
	pushAttentionList_({ commit }, newElement) {
		commit(types.ATTENTION_LIST, newElement);
	},
	pushErrorList_({ commit }, { key, value }) {
		commit(types.ERROR_LIST, { key, value });
	},

	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getList({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'mainResultList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce_({ commit }) {
		try {
			function sortCommCdList(commCd, val) {
				const key = _.camelCase(commCd) + 'CdList';
				const list = [];
				val.length && val.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				commit(types.DEFAULT_ASSIGN, { key, value: list });
			}
			const { header, body } = await api.getCommCodesOnce();
			if (header.code === 0) {
				for (const [key, val] of Object.entries(body)) {
					sortCommCdList(key, val);
				}
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error?.header || error;
		}
	},
	async getPopupList_({ commit, dispatch }, hasChanged) {
		try {
			if (hasChanged) {
				await commit(types.POPUP_SEARCH_PARAM, { key: 'changeCustCd', value: 'Y' });
			} else {
				await commit(types.POPUP_SEARCH_PARAM, { key: 'changeCustCd', value: '' });
			}
			return await dispatch('fetchList_');
		} catch (error) {
			throw error.header || error;
		}
	},
	async fetchList_({ commit, state }, printMode) {
		try {
			const { popupSearchParams } = state;
			const data = await api.getPopupList({ popupSearchParams, printMode });
			if (data?.header?.code === 0) {
				const { result, resultList, ngReport, feTarget, ubiTarget } = data.body;
				if (printMode) {
					data.header = { ...data.header, feTarget, ubiTarget };
					commit(types.DEFAULT_ASSIGN, { key: 'okReport', value: resultList });
					ngReport && commit(types.DEFAULT_ASSIGN, { key: 'ngReport', value: ngReport });
				} else {
					result && commit(types.DEFAULT_ASSIGN, { key: 'selectedRow', value: result });
					commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
				}
			} else if (data.header.code === 3) {
			}
			return data?.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getSgrpList_({ state, dispatch }) {
		const { lgrpCd } = state.selectedRow;
		const key = 'sgrpCdList';
		await dispatch('getCommCodes_', { key, codeType: lgrpCd });
	},
	async getAllSgrpList_({ state, dispatch, commit }) {
		const { lgrpCdList } = state;
		const key = 'sgrpAllList';
		commit(types.DEFAULT_ASSIGN, { key, value: [] });
		for (const lgrp of lgrpCdList) {
			await dispatch('getAllCommCodes_', { key, codeType: lgrp.value });
		}
	},
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw error?.header || error;
		}
	},
	async saveData_({ state }, data) {
		try {
			const response = await api.saveData(data);
			return response;
		} catch (error) {
			throw error?.header || error;
		}
	},
	async updateImg_({ state }, data) {
		try {
			const response = await api.updateImg(data);
			return response;
		} catch (error) {
			throw error?.header || error;
		}
	},
	// 출력시 출력상태 업데이트
	async updateOputSt_({ state }) {
		try {
			const { pmcNo, ipnNos, oputStCd } = state.selectedRow;
			const response = await api.updateOputSt({ pmcNo, ipnNos, oputStCd });
			return response;
		} catch (error) {
			throw error?.header || error;
		}
	}
};
